import { render, staticRenderFns } from "./BasicProject.vue?vue&type=template&id=1e6cf3cb&scoped=true&"
import script from "./BasicProject.vue?vue&type=script&lang=js&"
export * from "./BasicProject.vue?vue&type=script&lang=js&"
import style0 from "./BasicProject.vue?vue&type=style&index=0&id=1e6cf3cb&scoped=true&lang=css&"
import style1 from "./BasicProject.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6cf3cb",
  null
  
)

export default component.exports